export default __webpack_public_path__ + "static/media/instagram.754d06d4.svg";